import { createAsyncThunk } from '@reduxjs/toolkit';

import { partnerAPI } from '@/modules/partner/api';
import { TPartnerType } from '@/modules/partner/model/partnerType';
import { namespace } from '@/modules/partner/namespace';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { setDocDefinitions } from '../actions';

const loadPartnerDocDefinitions = createAsyncThunk(
  `${namespace}/fetch-doc-definitions`,
  async (partnerType: TPartnerType | undefined, { dispatch }): Promise<ThunkResult> => {
    if (!partnerType) {
      return { isSucceed: false };
    }

    dispatch(setDocDefinitions([]));

    const docs = await partnerAPI.fetchDocDefinitions(partnerType);

    dispatch(setDocDefinitions(docs));

    return { isSucceed: true };
  },
);

export { loadPartnerDocDefinitions };
